import { FC, ReactNode } from 'react'
import { useParams } from 'react-router-dom'
import { CustomerFeatureFlagsProvider } from 'src/context/CustomerFeatureFlagsProvider'

type Props = {
  children: ReactNode
}

/**
 * Supplies per-customer feature flags to client-admin chrome (e.g. sidebar) outside route outlets.
 * Route content can rely on {@link useAppFeatureFlags} with auto scope instead.
 */
export const CustomerAppFeatureScope: FC<Props> = ({ children }) => {
  const { id } = useParams<{ id?: string }>()
  const customerId = Number(id)

  if (!Number.isFinite(customerId) || customerId <= 0) {
    return <>{children}</>
  }

  return <CustomerFeatureFlagsProvider customerId={customerId}>{children}</CustomerFeatureFlagsProvider>
}
